import { Trans } from '@lingui/macro'
import { TableDataContainer } from 'components/Table'
import { PAGE_SIZE } from 'graphql/data/TopTokens'
import { GridContainer, NoTokensState } from 'pages/Liquidity/Table'
import { useOrderList } from 'pages/Trade/Hooks'
import { AlertTriangle } from 'react-feather'

import { HeaderRow, LoadedRow, LoadingRow } from './LimitRow'

const LoadingRows = ({ rowCount }: { rowCount: number }) => (
  <>
    {Array(rowCount)
      .fill(null)
      .map((_, index) => {
        return <LoadingRow key={index} first={index === 0} last={index === rowCount - 1} />
      })}
  </>
)

function LoadingTokenTable({ rowCount = PAGE_SIZE }: { rowCount?: number }) {
  return (
    <GridContainer>
      <HeaderRow />
      <TableDataContainer>
        <LoadingRows rowCount={rowCount} />
      </TableDataContainer>
    </GridContainer>
  )
}

export default function Table() {
  // const chainName = validateUrlChainParam(useParams<{ chainName?: string }>().chainName)

  const limitList = useOrderList()
  const loadingLimits = false

  /* loading and error state */
  if (loadingLimits && !limitList) {
    return <LoadingTokenTable rowCount={PAGE_SIZE} />
  } else if (!limitList) {
    return (
      <NoTokensState
        thRow={<HeaderRow />}
        message={
          <>
            <AlertTriangle size={16} />
            <Trans>An error occurred loading limitList. Please try again.</Trans>
          </>
        }
      />
    )
  } else if (limitList?.length === 0) {
    return <NoTokensState thRow={<HeaderRow />} message={<Trans>No limitList found</Trans>} />
  } else {
    return (
      <>
        <HeaderRow />
        <TableDataContainer>
          {limitList?.map((limit, index: any) => (
            <LoadedRow key={index} limitListIndex={index} limitListLength={limitList.length} limit={limit} />
          ))}
        </TableDataContainer>
      </>
    )
  }
}
